export default {
  // KakaoProfile
  profileName: '프로필명',
  category: '카테고리',
  registrationDate: '등록일시',
  id: 'ID',
};
